import { TextField, ArrayField, Datagrid } from "react-admin";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { Row } from "../ra-lb-tools/components/row";
import { MyList } from "../ra-lb-tools/components/myList";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { SetupStepCreateDialog } from "../ra-lb-tools/components/createStepDialog";
import { CardHeader } from "@mui/material";
export const SetupPLanIcon = FactCheckIcon;

export const SetupPlansList = () => (
  <MyList resource="tower-setup-plans">
    <TextField source="id" />
    <TextField source="name" />
    <TextField source="isDefault" />
  </MyList>
);

export const SetupPlansShow = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <MyShow {...props}>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary sx={{ justifyContent: "start" }}>
            <Row>
              <LabeledColumn>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="isDefault" label="Is Default" />
              </LabeledColumn>
            </Row>
          </RecordSummary>

          <CardHeader
            title="Steps"
            sx={{ paddingBottom: 0 }}
            action={
              <Button startIcon={<AddIcon />} onClick={() => setOpen(true)}>
                Add Step
              </Button>
            }
          />

          <ArrayField
            source="setupSteps"
            label={false}
            transform={(steps) => [...steps].sort((a, b) => a.order - b.order)}
          >
            <Datagrid bulkActionButtons={false}>
              <TextField source="id" />
              <TextField source="title" />
              <TextField source="order" />
              <TextField source="skippable" />
              <TextField source="isActive" />
            </Datagrid>
          </ArrayField>

          <SetupStepCreateDialog open={open} onClose={() => setOpen(false)} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
